var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticStyle:{"display":"inline-block"}},[_c('label',{staticStyle:{"margin-bottom":"1px"}},[_c('strong',[_vm._v(_vm._s(_vm.label))])]),_c('br'),_vm._v(_vm._s(_vm.value)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }